import { ERequestStatus } from '../../../types/requestStatus';
import { TCommentListState } from '../../../types/commentList';
import { POST_CARD_COMMENTS_REQUEST_LIMIT } from '../../../constants';

export const defaultState: TCommentListState = {
  status: ERequestStatus.Initial,
  meta: {
    limit: POST_CARD_COMMENTS_REQUEST_LIMIT,
    offset: 0,
    total: 0,
  },
  items: [],
};
